import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    defaultPageSize,
    pageSizeOptions,
    showSizeChanger,
    AsumsiIcon,
    IColumnProps, Table, Tooltip, Confirm
} from 'asumsi-components';
import moment from "moment";
import { IPostAuthor } from '@interfaces/iresponse-post';
import { Tag } from "antd";

export default function (props: any) {
    const { dataSource, metaData, onTableChange, loading } = props;
    const [showConfirmation, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(false);

    const showConfirm = async (e: any) => {
        e.preventDefault();
        setDeleteId(e.target.id);
        setShowConfirm(true);
    };

    const columns: IColumnProps[] = [
        {
            dataIndex: 'title',
            key: 'title',
            title: 'Title',
            sorter: true,
        },
        {
            dataIndex: 'authors',
            key: 'authors',
            title: 'Authors',
            sorter: false,
            render: (text: any) => {
                const auth: string[] = [];
                text.forEach((authors: IPostAuthor) => auth.push(`${authors.firstName} ${authors.lastName ?? ""}`));
                return auth.map((author: string) => <Tag color="geekblue">{author}</Tag>);
            }
        },
        {
            dataIndex: 'tags',
            key: 'tags',
            title: 'Tags',
            sorter: false,
            render: (text: any) => text && text.length > 0 && text.filter((ft: string) => ft != "null").map((tag: string) => <Tag color="magenta">{tag}</Tag>)
        },
        {
            dataIndex: 'topic',
            key: 'topic',
            title: 'Topic',
            sorter: true,
            render: (text: any) => text.name
        },
        {
            dataIndex: 'status',
            key: 'status',
            title: 'Status',
            sorter: true,
            render: (text: any) => text
        },
        {
            dataIndex: 'publishDateTime',
            key: 'publishDateTime',
            title: 'Published Date',
            columnWidht: "10%",
            sorter: true,
            render: (text: string) => text ? moment(text).format('DD MMM YYYY HH:mm') : "-"
        },
        {
            dataIndex: 'action',
            key: 'action',
            render: (text: string, record: any) => {
                return (
                    <div className="bt-table__action">
                        <Tooltip text="edit">
                            <Link to={`/article/posts/form/${record.id}`} style={{ marginRight: "8px" }}>
                                <AsumsiIcon icon="annotation" />
                            </Link>
                        </Tooltip>
                        <Tooltip text="hapus">
                            <Link to="" style={{ marginRight: "5px" }}>
                                <AsumsiIcon id={record.id} onClick={showConfirm} icon="trash" />
                            </Link>
                        </Tooltip>
                    </div>
                );
            },
            columnWidht: "8%",
            title: 'Action',
        },
    ];

    return (
        <Fragment>
            <Table columns={columns}
                dataSource={dataSource}
                className="asumsi-table"
                loading={loading}
                pagination={{
                    currentPage: metaData ? metaData.page : 1,
                    defaultPageSize: metaData ? metaData.limit : defaultPageSize,
                    pageSizeOptions,
                    showSizeChanger,
                    total: metaData ? metaData.totalRecords : 0,
                }}
                rowKey="id"
                onChange={onTableChange}
                upperCaseTitle={true}
            ></Table>
            <Confirm
                loading={loading}
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    await props.deleteData(deleteId);
                    props.fetchDataList();
                }}
                content='Are you sure you want to delete this item?'
                title='Konfirmasi'
                okText='Delete'
            />
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/pages/post/libraries/table.tsx